import * as React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import { App } from "./app";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { env } from "@/config/env";

// enableMocking().then(() => {
//   createRoot(root).render(
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   );
// });

// 1. Initialize Sentry BEFORE React boots up
Sentry.init({
  dsn: env.SENTRY_DSN, // Add to your .env and GitHub Vars
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(), // Optional: Records a video of crashes
  ],
  tracesSampleRate: 0.1, // Tracks performance of 10% of users
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0, // Always record a video if an error happens!
});

const root = document.getElementById("root");
if (!root) throw new Error("No root element found");

createRoot(root).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
